import {ModuleConfiguration} from "../router/model/UserPermission";
import {NAVIGATABLE_MODULE_NAME} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const NavigatableModule = new ModuleConfiguration(NAVIGATABLE_MODULE_NAME, [
    AngularJsMaterialModuleName
]);